import getBasePath from '../../functions/api-resource';

const basePath = getBasePath('planejamento_acao', 'acao/aprovada');

const planejamentoAcaoActions = {
  atualizarAcao: { method: 'PUT', url: `${basePath}` },
};

export default (resource) => resource(`${basePath}`, {}, planejamentoAcaoActions);
